import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';

const InvoiceDetailPage = () => {
  const { invoiceId } = useParams();
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [products, setProducts] = useState([]);
  const [logs, setLogs] = useState([]);
  const printRef = useRef();

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getInvoiceDetails.php?id=${invoiceId}`);
        const data = await response.json();
        if (data.success) {
          setInvoiceDetails(data.invoice);
          setProducts(data.products);
        }
      } catch (error) {
        console.error('Error fetching invoice details:', error);
      }
    };

    const fetchInvoiceLogs = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getInvoiceLogs.php?id=${invoiceId}`);
        const data = await response.json();
        if (data.success) {
          setLogs(data.logs);
        }
      } catch (error) {
        console.error('Error fetching logs:', error);
      }
    };

    fetchInvoiceDetails();
    fetchInvoiceLogs();
  }, [invoiceId]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <Header />
      <style>
        {`
          .invoice-container {
            max-width: 1000px;
            margin: 40px auto;
            padding: 30px;
            background: #fefefe;
            border-radius: 12px;
            box-shadow: 0 8px 24px rgba(0,0,0,0.15);
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }
          .invoice-container h1 {
            text-align: center;
            font-size: 28px;
            margin-bottom: 30px;
            color: #1a1a1a;
          }
          .section {
            margin-bottom: 30px;
          }
          .section h2 {
            font-size: 20px;
            margin-bottom: 15px;
            border-bottom: 2px solid #4b3c7c;
            padding-bottom: 5px;
            color: #4b3c7c;
          }
          .info p {
            margin: 6px 0;
            font-size: 15px;
            color: #333;
          }
          .product-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          .product-table th, .product-table td {
            border: 1px solid #ddd;
            padding: 12px 15px;
            text-align: left;
          }
          .product-table th {
            background: #4b3c7c;
            color: #fff;
            font-weight: 600;
          }
          .product-table tr:nth-child(even) {
            background: #f8f8f8;
          }
          .logs-list {
            list-style: none;
            padding: 0;
            margin-top: 10px;
          }
          .logs-list li {
            padding: 15px 20px;
            margin-bottom: 10px;
            background: #f4f4f4;
            border-left: 4px solid #4b3c7c;
            border-radius: 6px;
          }
          .logs-list p {
            margin: 4px 0;
            font-size: 14px;
            color: #444;
          }
          .print-btn {
            display: block;
            width: 220px;
            margin: 25px auto 50px;
            padding: 12px 0;
            background: #4b3c7c;
            color: #fff;
            border: none;
            border-radius: 8px;
            font-size: 17px;
            font-weight: 500;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            transition: all 0.3s ease;
          }
          .print-btn:hover {
            background: #4b3c7c;
            transform: translateY(-2px);
          }

          /* Responsive */
          @media (max-width: 768px) {
            .invoice-container {
              padding: 20px;
            }
            .product-table th, .product-table td {
              padding: 10px;
              font-size: 14px;
            }
          }
        `}
      </style>

      <div className="invoice-container" ref={printRef}>
        <h1>Invoice Details</h1>

        {invoiceDetails ? (
          <div className="section">
            <div className="info">
              <p><strong>Invoice ID:</strong> {invoiceDetails.id}</p>
              <p><strong>Total Price:</strong> {invoiceDetails.total}</p>
              <p><strong>Pending Amount:</strong> {invoiceDetails.pending}</p>
              <p><strong>Received Amount:</strong> {invoiceDetails.received}</p>
              <p><strong>Booker:</strong> {invoiceDetails.booker}</p>
              <p><strong>Supplier:</strong> {invoiceDetails.supplier}</p>
              <p><strong>Date:</strong> {invoiceDetails.date}</p>
              <p><strong>Time:</strong> {invoiceDetails.time}</p>
            </div>
          </div>
        ) : (
          <p>Loading invoice details...</p>
        )}

        <div className="section">
          <h2>Products</h2>
          {products.length > 0 ? (
            <table className="product-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Variant</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Rate</th>
                </tr>
              </thead>
              <tbody>
                {products.map(product => (
                  <tr key={product.id}>
                    <td>{product.product}</td>
                    <td>{product.variant || 'None'}</td>
                    <td>{product.qty}</td>
                    <td>{product.product_price}</td>
                    <td>{product.rate || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No products available for this invoice.</p>
          )}
        </div>

        <div className="section">
          <h2>Invoice Logs</h2>
          {logs.length > 0 ? (
            <ul className="logs-list">
              {logs.map((log, index) => (
                <li key={index}>
                  <p><strong>Reciver:</strong> {log.reciver}</p>
                  <p><strong>Received:</strong> {log.received}</p>
                  <p><strong>Form Date:</strong> {log.form_date}</p>
                  <p><strong>System Date:</strong> {log.system_datetime}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>No logs found for this invoice.</p>
          )}
        </div>
      </div>

      <button className="print-btn" onClick={handlePrint}>
        Print Invoice Details
      </button>
      <br></br><br></br>    
      <Footer />
    </>
  );
};

export default InvoiceDetailPage;
